// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorBoundary_root__y7ViO","error":"ErrorBoundary_error__Pm5A7"};